<template>
    <div class="FormRestore">
        <v-easy-dialog v-model="simpleDialog">
            <div class="flex flex-col v-card textSend">
            <div>
                <p class = "titleModal">
                    <strong>Confirmamos la recepción de la solicitud, A continuación los pasos del proceso de gestión:</strong>
                </p>
            </div>
            <hr/>
            <div class = "infoModal">
                <p>
                    Te daremos respuesta en tu caso presentado bajo el n°: {{this.sendCase}}
                </p>
            </div>

            <div class="flex justify-end space-x-2">
                <button id="btnClose" @click="simpleDialog = false" style="float: right;">Cerrar</button>
            </div>
            </div>
        </v-easy-dialog>
        <div v-if="FormRestore">
            <div class="container container-form">
                <div class="row">
                    <div class="col-md-6 infoForm">
                        <FormDataInscription/>
                    </div>
                    <div class="col-md-6 totalform motBusUser">  
                        <div v-if="infoData" class="alert alert-danger">
                            <p>
                                Estimado usuario. Tus datos no han podido ser validados por nuestro sistema de información. Te invitamos a comunicarte a nuestra línea de atención al 
                                estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co.
                            </p>
                        </div>
                        <div v-if="infoCorrect" class="alert alert-success">
                            <p>
                                Gracias, Tu información ha sido recibida  con éxito, se ha creado el caso y será atendido lo más pronto posible.
                            </p>
                        </div>
                        <h1 class="titleForm"><strong>¿Has olvidado tu clave? ¡No te preocupes!</strong></h1>
                        <p class="descriptionForm">
                            Si nunca has ingresado a tu correo electrónico institucional es posible que tu contraseña esté compuesta de: <strong>las 4 primeras letras de tu apellido en mayúscula, los 4 últimos dígitos de tu número de identidad, más un asterisco (*).</strong> Ejemplo: RODR1234*
                        </p>
                        <p class="descriptionFormSub">
                            Si esto no te funciona, pasemos al siguiente punto:
                        </p>
                        <p class="descriptionForm">
                            Diligencia el formulario que encontrarás a continuación y, de inmediato, recibirás un mensaje de texto al celular que tienes registrado con nosotros incluyendo tu nueva contraseña para ingreso al Correo Institucional. Tendrás respuesta de tu solicitud dentro de 15 minutos a partir del diligenciamiento del formulario.
                        </p>
                        <ValidationObserver ref="obsformRestore">
                            <FormRestore :FieldsForm="formRestore" :ModelForm="formInsModel" :method="executeProcess" />                                     
                        </ValidationObserver>
                        <div class="botoPnrocess">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <button
                                            id="UpdateUser"
                                            type="submit"
                                            v-on:click="onComplete"
                                            class="loginbtn">
                                            Enviar
                                        </button>
                                    </div>
                                    <div class="col-md-4"></div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormDataInscription from '@/views/InfoZone/FormPassword.vue'
    import FormRestore from '@/components/Forms.vue'
    import IberoHelpers from '@/store/helpers.js'
    import VEasyDialog from 'v-easy-dialog'

    export default{
        name: "FormRestores",
        components: {
            FormDataInscription,
            FormRestore,
            VEasyDialog,
        },
        methods:{
            dataObjCheck: function(InfDaT){
                if(InfDaT === true){
                    return this.$ml.get('Accepted');   
                }
                return this.$ml.get('NotAccepted');    
            },
            dataformat: function(InfDaT){
                return IberoHelpers.dataObjDate(InfDaT);
            },
            dataObjFindJs: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjFind(infoDaT,FinDaT);
            },
            dataObjAllFind: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjAllFind(infoDaT,FinDaT);
            },
            executeProcess: function (event){
                
            },
            clearForm: function(){
                this.infoData = false;
                this.formInsModel.IdName = '';
                this.formInsModel.IdLastname = '';
                this.formInsModel.Mobile = '';
                this.formInsModel.Email = '';
                this.formInsModel.Document = '';
                this.formInsModel.IdBanner = '';
                this.formInsModel.IdRequest = '';
                this.formInsModel.Message = '';

                this.formRestore[0].validate = false;
                this.formRestore[1].validate = false;
                this.formRestore[2].validate = false;
                this.formRestore[3].validate = false;
                this.formRestore[4].validate = false;
                this.formRestore[5].validate = false;
                this.formRestore[6].validate = false;
                this.formRestore[7].validate = false;
            },
            onComplete: function() {
                return new Promise((resolve, reject) => {
                    this.$refs.obsformRestore.validate().then(results => {
                        if(!results){
                            IberoHelpers.scrollToTop(0,300);
                            resolve(false)
                        }
                        else{
                            let loader = this.$loading.show();
                            var createCase = IberoHelpers.sendCaseZoho(this.$store,this.formInsModel);
                            createCase.then(Response => {
                                debugger
                                let numCase  = Response.data.title;
                                this.sendCase = numCase;
                                if (!(Response === false)) {
                                    if (Response.data.status === '200') {                                
                                        loader.hide();
                                        IberoHelpers.scrollToTop(0,500);
                                        this.infoData = false;
                                        this.simpleDialog = true;
                                        this.clearForm();                                       
                                        resolve(true)
                                    } else {
                                        loader.hide();
                                        this.infoData = true;
                                        resolve(false);
                                    }
                                }
                                else
                                {
                                    loader.hide();
                                    this.infoData = true;
                                    resolve(false);
                                }
                            })
                        }
                    });
                });
            },
        },
        data(){
            return {
                FormRestore: true,
                infoData: false,
                infoCorrect: false,
                dangerData: false,
                simpleDialog: false,
                sumaryData: [],
                sendCase: [],
                formInsModel:{
                    Campaign: this.$route.params.referencia,
                    IdName: '',
                    IdLastname: '',
                    Mobile: '',
                    Email: '',
                    Document: '',
                    IdBanner: '',
                    IdRequest: '',
                    Message: '',
                },
                formRestore:[
                    {            
                        id: 'IdName',
                        model: 'IdName',
                        name: 'Nombres',
                        type: 'input',  
                        placeholder: 'Nombres',
                        values: '',
                        readonly:"isReadOnly",
                        validate: {              
                        required: true, 
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdLastname',
                        model: 'IdLastname',
                        name: 'Apellidos',
                        type: 'input',  
                        placeholder: 'Apellidos',
                        values: '',
                        validate: {              
                        required: true
                        },
                        class: 'col-md-6'               
                    },
                    {            
                        id: 'Mobile',
                        model: 'Mobile',
                        name: 'Teléfono Celular',
                        type: 'input',  
                        placeholder: 'Teléfono Celular',
                        values: '',
                        validate: {
                        required: true, 
                        numeric: true,
                        max: 10,
                        min: 10 
                        },  
                        class: 'col-md-6'               
                    },  
                    {            
                        id: 'Email',
                        model: 'Email',
                        name: 'Correo Institucional',
                        type: 'input',  
                        placeholder: 'Correo Institucional',
                        values: '',
                        validate: {
                        required: true, 
                        email: true 
                        },
                        class: 'col-md-6'               
                    },  
                    {            
                        id: 'Document',
                        model: 'Document',
                        name: 'Documento de Identidad',
                        type: 'input',  
                        placeholder: 'Documento de Identidad',
                        values: '',
                        validate: {              
                        required: true, 
                        min: 5,              
                        max: 12            
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdBanner',
                        model: 'IdBanner',
                        name: 'ID Banner',
                        type: 'input',  
                        placeholder: 'ID Banner',
                        values: '',
                        validate: {              
                        required: true, 
                        min: 5,              
                        max: 12            
                        },
                        class: 'col-md-6'               
                    },
                    {
                        id: 'IdRequest',
                        model: 'IdRequest',
                        name: 'Tipo de Solicitud',
                        type: 'Select',  
                        placeholder: 'Tipo de Solicitud',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-12',
                        values: [
                            { id: "3229357000002965841", value: "INGRESO AL CORREO ELECTRÓNICO INSTITUCIONAL" },
                            { id: "3229357000063135295", value: "SOLICITUD DE CREACIÓN DE CORREO ELECTRÓNICO INSTITUCIONAL" },
                        ],
                    },  
                    {            
                        id: 'Message',
                        model: 'Message',
                        name: 'Mensaje',
                        type: 'textarea',
                        hint: "Max 500 caracteres",
                        max: 500,
                        placeholder: 'Mensaje',
                        rows: 5,
                        values: '',
                        validate: 
                        {
                            required: true, 
                        },
                        class: 'col-md-12',
                        styleClasses: 'height: 200px'            
                    }
                ]
            }
        }
    }
</script>

<style scope>
.InscPayOrder{
    margin: 20px;
}
.totalformList{
    margin-bottom: 10px;
}
.img-fluid{
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;    
}

.txtBusUser{
    padding: 40px;
}

.titleRef {
    font-weight: bold;
    padding-bottom: 0px;
    margin-top: 20px;
}

.titleForm {
    color: #222;
}

.descriptionForm {
    padding: 10px 10px 0px 10px;
    font-size: 12px;
    margin: 0px;
}

.descriptionFormSub{
    padding: 10px 10px 0px 10px;
    font-size: 12px;
    margin: 0px;
    color: #f2a900;
}

.lisDataUser{
    padding: 10px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #ffffff;
    background:  #ffffff !important;       
    margin-bottom: 5px;
}

.container-form{
    padding: 30px 0;
    box-sizing: border-box;
}

.motBusUser{
    /* padding: ; */
    border-radius: 5px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    background:  #ffffff !important;       
}

body {
    background:  #fff !important;   
}
header {
    background:  #ffffff !important;   
}

.table > tbody > tr > td {
     vertical-align: middle !important;
}

.linksActas{
    padding: 20px;
    float: right;
}

.linksReference{
    margin-top: 20px;
    padding: 20px;
    float: right;
}

.linksActas a {
  color: #222;
}

.active
{
    color: #222;
}

#IdObservation {
    height: 90px;
}

.botoPnrocess {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 10px;
}
button:hover {
  background-color: #222;
  color: #fff;
}
.loginbtn {
  width: 90%;
  border: #222 solid 1px !important;
  background-color: #fff;
  color: #222;
  border-radius: 10px 10px;
  padding: 10px 0px 10px 0px;
}

.validateBtn{
    width: 90%;
    border-color: #222;
    background-color: #fff;
    color: #222;
    border-radius: 10px 10px;
    padding: 10px 0px 10px 0px;
    margin: 0px 10px 10px 10px;
}

/* Modal validación de datos */
.InscFiles{
    margin: 20px;
}

/* Grid validación data */
.wrapper {
  display: grid;
  margin: 10px 10px 10px 10px;
  padding: 1px 1px 1px 1px;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid black;
  grid-gap: 1px;
  background-color: black;
}

.wrapper > div {
  background-color: white;
  padding: 10px;
  text-align: center;
}

/* Estilos dedicados al Modal */
#btnClose{
    margin: 10px 10px 10px 10px;
    border-radius: 5px;
    border-color: #222;
    background-color: #fff;
    color: #222;
}
#btnClose:hover{
    background-color: #222;
    color: #fff;
}
hr{
    margin: 5px 10px;
}
.titleModal{
    font-size: 20px !important;
}
.v-easy-dialog--transition-ease-in {
    transform: scale(1);
    transition: opacity cubic-bezier(0.4, 0, 1, 1) 0.15s,
        transform cubic-bezier(0.4, 0, 1, 1) 0.15s;
}
.v-easy-dialog--transition-ease-out {
    transform: scale(1);
    transition: opacity cubic-bezier(0, 0, 0.2, 1) 0.15s,
        transform cubic-bezier(0, 0, 0.2, 1) 0.15s;
}
.v-easy-dialog--content-transition-opened {
    opacity: 1;
    transform: scale(1);
}
.v-easy-dialog--content-transition-closed {
    opacity: 0;
    transform: scale(0);
}
.v-easy-dialog--opacity-0 {
    opacity: 0;
}
.v-easy-dialog--opacity-100 {
    opacity: 100;
}
.v-easy-dialog--backdrop {
    z-index: 1050;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    touch-action: none;
}
.v-easy-dialog--backdrop-btn {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    cursor: default;
}
.v-easy-dialog--backdrop-btn:hover{
    background-color: rgba(0, 0, 0, 0) !important;
}
.v-easy-dialog--fullscreen {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
}
.v-easy-dialog--content-grow *:first-child {
    flex-grow: 1;
}
.v-easy-dialog--content-container {
    display: flex;
    overflow-y: auto;
    position: absolute;
    touch-action: none;
}
.v-easy-dialog--content-container:focus {
    outline: none;
}
.v-easy-dialog--persist {
    animation: shake 0.15s;
}

.textSend{
    background-color: #fff;
    border-radius: 10px;
}

.textSend div p{
    padding: 10px 10px 10px 10px;
    margin: 0px 0px 0px 0px;
    color: #000;
    font-size: 15px;
}
@keyframes shake {
    0% {
        transform: translate(1px, 1px) rotate(0deg);
    }
    20% {
        transform: translate(-3px, 0px) rotate(1deg);
    }
    40% {
        transform: translate(1px, -1px) rotate(1deg);
    }
    60% {
        transform: translate(-3px, 1px) rotate(0deg);
    }
    80% {
        transform: translate(-1px, -1px) rotate(1deg);
    }
    100% {
        transform: translate(1px, -2px) rotate(-1deg);
    }
}

</style>